<template>
  <div class="rb-codebox" :style="{ '--rb-min': rows * 20 + 'px', '--rb-h': maxHeight ? maxHeight + 'px' : 'auto' }">
    <codemirror :value="value" :options="cmOptions" @input="$emit('input', $event)" />
  </div>
</template>

<script>
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/sql/sql.js'

const MODES = { sql: 'text/x-pgsql', js: 'text/javascript', json: { name: 'javascript', json: true } }

export default {
  name: 'RbCodeBox',
  props: {
    value: { type: String, default: '' },
    mode: { type: String, default: 'sql' },
    rows: { type: Number, default: 6 },
    readOnly: Boolean,
    // fixed-height scrolling editor for very long documents (renders only the visible lines)
    maxHeight: { type: Number, default: 0 }
  },
  computed: {
    cmOptions () {
      return {
        tabSize: 2, indentWithTabs: false, lineNumbers: true, lineWrapping: true, viewportMargin: this.maxHeight ? 60 : Infinity,
        mode: MODES[this.mode] || MODES.sql, readOnly: this.readOnly
      }
    }
  }
}
</script>

<style scoped>
.rb-codebox { border: 1px solid rgba(128, 128, 128, 0.4); border-radius: 4px; }
.rb-codebox ::v-deep .CodeMirror { height: var(--rb-h); min-height: var(--rb-min); font-size: 13px; }
</style>
